export const actionTypes: any = {
  // get Banners
  GET_BANNER_OFFER_START: 'GET_BANNER_OFFER_START',
  GET_BANNER_OFFER_SUCCESS: 'GET_BANNER_OFFER_SUCCESS',
  GET_BANNER_OFFER_FINISH: 'GET_BANNER_OFFER_FINISH',

  // get Banners
  GET_ALL_BANNER_OFFER_START: 'GET_ALL_BANNER_OFFER_START',
  GET_ALL_BANNER_OFFER_SUCCESS: 'GET_ALL_BANNER_OFFER_SUCCESS',
  GET_ALL_BANNER_OFFER_FINISH: 'GET_ALL_BANNER_OFFER_FINISH',

  // get Color OPtion
  GET_BANNER_COLOR_OPTION_START: 'GET_BANNER_COLOR_OPTION_START',
  GET_BANNER_COLOR_OPTION_SUCCESS: 'GET_BANNER_COLOR_OPTION_SUCCESS',
  GET_BANNER_COLOR_OPTION_FINISH: 'GET_BANNER_COLOR_OPTION_FINISH',

  //Add Banner
  ADD_BANNER_OFFER_REQUEST: 'ADD_BANNER_OFFER_REQUEST',
  ADD_BANNER_OFFER_SUCCESS: 'ADD_BANNER_OFFER_SUCCESS',
  ADD_BANNER_OFFER_FINISH: 'ADD_BANNER_OFFER_FINISH',
  ADD_BANNER_OFFER_RESET: 'ADD_BANNER_OFFER_RESET',

  // update Banner
  UPDATE_BANNER_OFFER_START: 'UPDATE_BANNER_OFFER_START',
  UPDATE_BANNER_OFFER_SUCCESS: 'UPDATE_BANNER_OFFER_SUCCESS',
  UPDATE_BANNER_OFFER_FINISH: 'UPDATE_BANNER_OFFER_FINISH',
  UPDATE_BANNER_OFFER_RESET: 'UPDATE_BANNER_OFFER_RESET',

  //Bulk Activate Banner
  ACTIVATE_BANNER_OFFER_REQUEST: 'ACTIVATE_BANNER_OFFER_REQUEST',
  ACTIVATE_BANNER_OFFER_SUCCESS: 'ACTIVATE_BANNER_OFFER_SUCCESS',
  ACTIVATE_BANNER_OFFER_FINISH: 'ACTIVATE_BANNER_OFFER_FINISH',

  //Bulk Deactivate Banner
  DEACTIVATE_BANNER_OFFER_REQUEST: 'DEACTIVATE_BANNER_OFFER_REQUEST',
  DEACTIVATE_BANNER_OFFER_SUCCESS: 'DEACTIVATE_BANNER_OFFER_SUCCESS',
  DEACTIVATE_BANNER_OFFER_FINISH: 'DEACTIVATE_BANNER_OFFER_FINISH',

  //Single Activate Banner
  SINGLE_ACTIVATE_BANNER_OFFER_REQUEST: 'SINGLE_ACTIVATE_BANNER_OFFER_REQUEST',
  SINGLE_ACTIVATE_BANNER_OFFER_SUCCESS: 'SINGLE_ACTIVATE_BANNER_OFFER_SUCCESS',
  SINGLE_ACTIVATE_BANNER_OFFER_FINISH: 'SINGLE_ACTIVATE_BANNER_OFFER_FINISH',

  //Single Deactivate Banner
  SINGLE_DEACTIVATE_BANNER_OFFER_REQUEST: 'SINGLE_DEACTIVATE_BANNER_OFFER_REQUEST',
  SINGLE_DEACTIVATE_BANNER_OFFER_SUCCESS: 'SINGLE_DEACTIVATE_BANNER_OFFER_SUCCESS',
  SINGLE_DEACTIVATE_BANNER_OFFER_FINISH: 'SINGLE_DEACTIVATE_BANNER_OFFER_FINISH',

  // delete Banner
  DELETE_BANNER_OFFER_START: 'DELETE_BANNER_OFFER_START',
  DELETE_BANNER_OFFER_SUCCESS: 'DELETE_BANNER_OFFER_SUCCESS',
  DELETE_BANNER_OFFER_FINISH: 'DELETE_BANNER_OFFER_FINISH',

  // sort
  SORT_BANNER_OFFER_START: 'SORT_BANNER_OFFER_START',
  SORT_BANNER_OFFER_SUCCESS: 'SORT_BANNER_OFFER_SUCCESS',
  SORT_BANNER_OFFER_FINISH: 'SORT_BANNER_OFFER_FINISH',
  SORT_BANNER_OFFER_RESET: 'SORT_BANNER_OFFER_RESET',
}
